(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["eleva-size-guide"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('eleva-size-guide')) {
  customElements.define('eleva-size-guide', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      const dialog = this.querySelector('dialog');
      const opener = this.querySelector('.eleva-size-guide__open');
      if (!dialog || !opener) return;
      opener.addEventListener('click', () => dialog.showModal());
      this.querySelector('.eleva-size-guide__close').addEventListener('click', () => dialog.close());
      dialog.addEventListener('click', event => {
        if (event.target === dialog) {
          const bounds = dialog.getBoundingClientRect();
          if (event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom) dialog.close();
        }
      });
      dialog.addEventListener('close', () => opener.focus({ preventScroll: true }));
    }
  });
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["shipping-calculator-cart"] && !Shopify.designMode) return;
  try {
    (function() {
    "use strict";
    var root = document.querySelector("[data-cart-calculator]");
    if (!root) return;

    /** Testa se o ViaCEP está online; se não estiver, oculta o calculador e o botão de frete do carrinho. */
    function checkViaCEP() {
      var url = "https://viacep.com.br/ws/01310100/json/";
      var timeoutMs = 5000;
      function tryFetch() {
        return Promise.race([
          fetch(url).then(function(r) { return r.json(); }).then(function() { return true; }),
          new Promise(function(_, rej) { setTimeout(function() { rej(new Error("timeout")); }, timeoutMs); })
        ]);
      }
      return tryFetch().catch(function() { return tryFetch(); }).catch(function() { return false; });
    }

    checkViaCEP().then(function(online) {
      if (!online) {
        root.style.display = "none";
        var addons = root.closest("m-cart-addons");
        if (addons) {
          var shippingBtn = addons.querySelector('button[data-open="shipping"]');
          if (shippingBtn) shippingBtn.style.display = "none";
        }
        return;
      }

      var shippingZip = document.getElementById("frete-cep-cart");
      var shippingCountry = document.getElementById("pais-simulator-cart");
      var shippingProvince = document.getElementById("estados-simulator-cart");
      var shippingMessage = document.getElementById("frete-error-cart");
      var freteLista = document.getElementById("frete-results-cart");
      var calcularBtn = document.getElementById("frete-calcular-cart");
      if (!shippingZip || !calcularBtn) return;

      var config = {
      errorMessage: root.dataset.errorMessage || "CEP não encontrado, tente novamente.",
      freeShippingText: root.dataset.freeShippingText || "Grátis"
    };

    function formatMoney(cents, format) {
      if (typeof window.MinimogSettings !== "undefined" && window.MinimogSettings.money_format) {
        format = window.MinimogSettings.money_format;
      }
      if (!format) format = "R$ {{amount}}";
      var value = (cents / 100).toFixed(2).replace(/\d(?=(\d{3})+\.)/g, "$1,");
      return format.replace("{{amount}}", value).replace("{{amount_no_decimals}}", Math.round(cents / 100)).replace("{{amount_with_comma_separator}}", value);
    }

    shippingZip.addEventListener("input", function(e) {
      var value = e.target.value.replace(/\D/g, "");
      if (value.length > 8) value = value.slice(0, 8);
      if (value.length > 5) value = value.slice(0, 2) + "." + value.slice(2, 5) + "-" + value.slice(5);
      else if (value.length > 2) value = value.slice(0, 2) + "." + value.slice(2);
      e.target.value = value;
    });

    function isDateBeforeToday(date) {
      return new Date(date.toDateString()) < new Date(new Date().toDateString());
    }
    function excludeDate(name) {
      return name !== "Entrega Expressa - pedidos feitos até 11h chegam em até 24hrs úteis" && name !== "Entrega Rápida - pedidos chegam em até 48hrs úteis";
    }

    calcularBtn.addEventListener("click", function(e) {
      e.preventDefault();
      var cepLimpo = shippingZip.value.replace(/\D/g, "");
      if (cepLimpo.length < 8) {
        shippingMessage.textContent = "CEP inválido";
        shippingMessage.style.display = "block";
        return;
      }
      shippingMessage.textContent = "";
      shippingMessage.style.display = "none";

      fetch("https://viacep.com.br/ws/" + cepLimpo + "/json/")
        .then(function(r) { return r.json(); })
        .then(function(dados) {
          if (!("erro" in dados)) {
            var ufMap = { "AC": "Acre", "AL": "Alagoas", "AP": "Amapa", "AM": "Amazonas", "BA": "Bahia", "CE": "Ceara", "DF": "Distrito Federal", "ES": "Espirito Santo", "GO": "Goias", "MA": "Maranhao", "MT": "Mato Grosso", "MS": "Mato Grosso do Sul", "MG": "Minas Gerais", "PA": "Para", "PB": "Paraiba", "PR": "Parana", "PE": "Pernambuco", "PI": "Piaui", "RJ": "Rio de Janeiro", "RN": "Rio Grande do Norte", "RS": "Rio Grande do Sul", "RO": "Rondonia", "RR": "Roraima", "SC": "Santa Catarina", "SP": "Sao Paulo", "SE": "Sergipe", "TO": "Tocantins" };
            shippingProvince.value = ufMap[dados.uf] || dados.uf;
            getRatesCart();
          } else {
            freteLista.innerHTML = "";
            freteLista.style.display = "none";
            shippingMessage.textContent = config.errorMessage;
            shippingMessage.style.display = "block";
          }
        })
        .catch(function() {
          freteLista.innerHTML = "";
          freteLista.style.display = "none";
          shippingMessage.textContent = config.errorMessage;
          shippingMessage.style.display = "block";
        });
    });

    function getRatesCart() {
      shippingMessage.style.display = "none";
      freteLista.style.display = "block";
      freteLista.innerHTML = '<div style="display:flex;justify-content:center;padding:20px;"><svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" style="animation:spin 1s linear infinite"><style>@keyframes spin{from{transform:rotate(0deg)}to{transform:rotate(360deg)}}</style><circle cx="12" cy="12" r="10" stroke="#d9d9d9" stroke-width="3" fill="none"/><path d="M12 2a10 10 0 0 1 10 10" stroke="#414141" stroke-width="3" fill="none" stroke-linecap="round"/></svg></div>';

      var params = new URLSearchParams({
        "shipping_address[country]": shippingCountry.value,
        "shipping_address[province]": shippingProvince.value,
        "shipping_address[zip]": shippingZip.value.replace(/\D/g, "")
      });

      fetch("/cart/shipping_rates.json?_easygift_internal=true&" + params.toString(), {
        credentials: "same-origin",
        headers: { "Content-Type": "application/json" }
      })
        .then(function(r) { return r.json(); })
        .then(function(d) {
          if (d.shipping_rates && d.shipping_rates.length) {
            freteLista.innerHTML = "";
            for (var i = 0; i < d.shipping_rates.length; i++) {
              var deliveryDate = d.shipping_rates[i].delivery_date;
              var entrega = deliveryDate ? new Date(d.shipping_rates[i].delivery_date) : null;
              var checkBeforeday = entrega ? isDateBeforeToday(entrega) : true;
              var excludeDateCheck = excludeDate(d.shipping_rates[i].name);
              var dataFormatada = entrega ? entrega.getDate() + "/" + (entrega.getMonth() + 1) + "/" + entrega.getFullYear() : "";
              var valorFrete = d.shipping_rates[i].price;
              if (valorFrete === "0.00" || valorFrete == null) valorFrete = config.freeShippingText;
              else valorFrete = formatMoney(parseFloat(valorFrete) * 100, null);
              var entregaText = "";
              if (deliveryDate == null && excludeDateCheck || (entrega && checkBeforeday && excludeDateCheck)) entregaText = "Estimativa de entrega indisponível";
              else if (!excludeDateCheck) entregaText = "";
              else entregaText = "(Estimativa de entrega: " + dataFormatada + ")";
              var freteItem = document.createElement("div");
              freteItem.className = "frete-item";
              freteItem.innerHTML = '<div class="frete-item__info"><p class="frete-item__name">' + d.shipping_rates[i].name + "</p>" + (entregaText ? '<span class="frete-item__delivery">' + entregaText + "</span>" : "") + "</div><div class=\"frete-item__price\">" + valorFrete + "</div>";
              freteLista.appendChild(freteItem);
            }
          } else {
            freteLista.innerHTML = "";
            freteLista.style.display = "none";
            shippingMessage.textContent = config.errorMessage;
            shippingMessage.style.display = "block";
          }
        })
        .catch(function(err) {
          console.error(err);
          freteLista.innerHTML = "";
          freteLista.style.display = "none";
          shippingMessage.textContent = config.errorMessage;
          shippingMessage.style.display = "block";
        });
    }
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["shipping-calculator"] && !Shopify.designMode) return;
  try {
    (function () {
    "use strict";

    var freteCalculo = document.querySelector('.frete-calculo');
    if (!freteCalculo) return;

    /** Testa se o ViaCEP está online; se não estiver, o bloco do calculador é ocultado. */
    function checkViaCEP() {
      var url = 'https://viacep.com.br/ws/01310100/json/';
      var timeoutMs = 5000;
      function tryFetch() {
        return Promise.race([
          fetch(url).then(function(r) { return r.json(); }).then(function() { return true; }),
          new Promise(function(_, rej) { setTimeout(function() { rej(new Error('timeout')); }, timeoutMs); })
        ]);
      }
      return tryFetch().catch(function() { return tryFetch(); }).catch(function() { return false; });
    }

    checkViaCEP().then(function(online) {
      if (!online) {
        freteCalculo.style.display = 'none';
        return;
      }

      var shippingZip = document.getElementById('frete-cep');
    var shippingCountry = document.getElementById('pais-simulator');
    var shippingProvince = document.getElementById('estados-simulator');
    var shippingMessage = document.getElementById('frete-error');
    var freteLista = document.getElementById('frete-results');
    var calcularBtn = document.getElementById('frete-calcular');

    if (!shippingZip || !calcularBtn) return;

    // Configurações dos data attributes
    var config = {
      errorMessage: freteCalculo.dataset.errorMessage || 'CEP não encontrado, tente novamente.',
      freeShippingText: freteCalculo.dataset.freeShippingText || 'Grátis'
    };

    // Seletor do produto
    var productSelect = document.getElementById('ProductSelect-product-template');
    if (!productSelect) productSelect = document.getElementsByName('id')[0];
    if (!productSelect) return;

    // Máscara de CEP (formato: 00.000-000)
    shippingZip.addEventListener('input', function(e) {
      var value = e.target.value.replace(/\D/g, '');
      if (value.length > 8) value = value.slice(0, 8);
      if (value.length > 5) {
        value = value.slice(0, 2) + '.' + value.slice(2, 5) + '-' + value.slice(5);
      } else if (value.length > 2) {
        value = value.slice(0, 2) + '.' + value.slice(2);
      }
      e.target.value = value;
    });

    // Click no botão calcular
    calcularBtn.addEventListener('click', function(e) {
      e.preventDefault();
      
      var cepLimpo = shippingZip.value.replace(/\D/g, '');
      if (cepLimpo.length < 8) {
        shippingMessage.innerHTML = 'CEP inválido';
        shippingMessage.style.display = 'block';
        return;
      }

      shippingMessage.innerHTML = '';
      shippingMessage.style.display = 'none';

      fetch("https://viacep.com.br/ws/" + cepLimpo + "/json/")
        .then(function(response) { return response.json(); })
        .then(function(dados) {
          if (!("erro" in dados)) {
            var ufMap = {
              'AC': 'Acre', 'AL': 'Alagoas', 'AP': 'Amapa', 'AM': 'Amazonas',
              'BA': 'Bahia', 'CE': 'Ceara', 'DF': 'Distrito Federal', 'ES': 'Espirito Santo',
              'GO': 'Goias', 'MA': 'Maranhao', 'MT': 'Mato Grosso', 'MS': 'Mato Grosso do Sul',
              'MG': 'Minas Gerais', 'PA': 'Para', 'PB': 'Paraiba', 'PR': 'Parana',
              'PE': 'Pernambuco', 'PI': 'Piaui', 'RJ': 'Rio de Janeiro', 'RN': 'Rio Grande do Norte',
              'RS': 'Rio Grande do Sul', 'RO': 'Rondonia', 'RR': 'Roraima', 'SC': 'Santa Catarina',
              'SP': 'Sao Paulo', 'SE': 'Sergipe', 'TO': 'Tocantins'
            };

            dados.uf = ufMap[dados.uf] || dados.uf;
            shippingProvince.value = dados.uf;

            var variantId = productSelect.value;
            if (!variantId) {
              var firstOption = productSelect.querySelector('option');
              if (firstOption) variantId = firstOption.value;
            }

            getRates(parseInt(variantId));
          } else {
            freteLista.innerHTML = "";
            freteLista.style.display = "none";
            shippingMessage.innerHTML = config.errorMessage;
            shippingMessage.style.display = "block";
          }
        })
        .catch(function() {
          freteLista.innerHTML = "";
          freteLista.style.display = "none";
          shippingMessage.innerHTML = config.errorMessage;
          shippingMessage.style.display = "block";
        });
    });

    function getRates(variantId) {
      if (typeof variantId === 'undefined') return;

      // Busca o input de quantidade da página do produto atual
      var productQuantity = document.querySelector('.m-main-product .m-quantity__input');
      var quantity = (productQuantity && productQuantity.value) ? parseInt(productQuantity.value) : 1;
      
      var addData = {
        'id': variantId,
        'quantity': quantity
      };

      var originalCartItems = [];

      function isDateBeforeToday(date) {
        return new Date(date.toDateString()) < new Date(new Date().toDateString());
      }

      function excludeDate(name) {
        return (name != 'Entrega Expressa - pedidos feitos até 11h chegam em até 24hrs úteis' && name != 'Entrega Rápida - pedidos chegam em até 48hrs úteis');
      }

      function restoreCart() {
        if (originalCartItems.length === 0) return Promise.resolve();
        
        return fetch('/cart/clear.js', {
          credentials: 'same-origin',
          headers: { 'Content-Type': 'application/json' },
          method: 'POST'
        }).then(function() {
          var itemsToAdd = originalCartItems.map(function(item) {
            return {
              id: item.variant_id,
              quantity: item.quantity,
              properties: item.properties
            };
          });
          
          return fetch('/cart/add.js', {
            body: JSON.stringify({ items: itemsToAdd }),
            credentials: 'same-origin',
            headers: { 'Content-Type': 'application/json' },
            method: 'POST'
          });
        });
      }

      // Mostra loading
      shippingMessage.style.display = "none";
      freteLista.style.display = "block";
      freteLista.innerHTML = '<div style="display: flex; justify-content: center; padding: 20px;"><svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" style="animation: spin 1s linear infinite;"><style>@keyframes spin { from { transform: rotate(0deg); } to { transform: rotate(360deg); } }</style><circle cx="12" cy="12" r="10" stroke="#d9d9d9" stroke-width="3" fill="none"/><path d="M12 2a10 10 0 0 1 10 10" stroke="#414141" stroke-width="3" fill="none" stroke-linecap="round"/></svg></div>';

      // 1. Busca os itens do carrinho atual
      fetch('/cart.js', {
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json' }
      })
      .then(function(response) { return response.json(); })
      .then(function(cart) {
        originalCartItems = cart.items || [];
        
        // 2. Limpa o carrinho
        return fetch('/cart/clear.js', {
          credentials: 'same-origin',
          headers: { 'Content-Type': 'application/json' },
          method: 'POST'
        });
      })
      .then(function() {
        // 3. Adiciona apenas o produto para cálculo
        return fetch('/cart/add.js', {
          body: JSON.stringify(addData),
          credentials: 'same-origin',
          headers: { 'Content-Type': 'application/json' },
          method: 'POST'
        });
      })
      .then(function(response) { return response.json(); })
      .then(function() {
        var params = new URLSearchParams({
          'shipping_address[country]': shippingCountry.value,
          'shipping_address[province]': shippingProvince.value,
          'shipping_address[zip]': shippingZip.value
        });

        // 4. Consulta as taxas de frete
        return fetch('/cart/shipping_rates.json?_easygift_internal=true&' + params.toString(), {
          credentials: 'same-origin',
          headers: { 'Content-Type': 'application/json' }
        });
      })
      .then(function(response) { return response.json(); })
      .then(function(d) {
        if (d.shipping_rates && d.shipping_rates.length) {
          freteLista.innerHTML = "";

          for (var i = 0; i < d.shipping_rates.length; i++) {
            var deliveryDate = d.shipping_rates[i].delivery_date;
            var entrega = new Date(d.shipping_rates[i].delivery_date);
            var checkBeforeday = isDateBeforeToday(entrega);
            var excludeDateCheck = excludeDate(d.shipping_rates[i].name);
            var dataFormatada = entrega.getDate() + "/" + (entrega.getMonth() + 1) + "/" + entrega.getFullYear();

            var valorFrete = d.shipping_rates[i].price;

            if (valorFrete == "0.00" || valorFrete == null) {
              valorFrete = config.freeShippingText;
            } else {
              valorFrete = formatMoney(valorFrete * 100, window.MinimogSettings.money_format);
            }

            var entregaText;
            if (deliveryDate == null && excludeDateCheck || checkBeforeday && excludeDateCheck) {
              entregaText = "Estimativa de entrega indisponível";
            } else if (!excludeDateCheck) {
              entregaText = "";
            } else {
              entregaText = "(Estimativa de entrega: " + dataFormatada + ")";
            }

            var freteItem = document.createElement('div');
            freteItem.className = 'frete-item';
            freteItem.innerHTML = '<div class="frete-item__info"><p class="frete-item__name">' + d.shipping_rates[i].name + '</p>' + (entregaText ? '<span class="frete-item__delivery">' + entregaText + '</span>' : '') + '</div><div class="frete-item__price">' + valorFrete + '</div>';
            freteLista.appendChild(freteItem);
          }
        } else {
          freteLista.innerHTML = "";
          freteLista.style.display = "none";
          shippingMessage.innerHTML = config.errorMessage;
          shippingMessage.style.display = "block";
        }
        restoreCart();
      })
      .catch(function(err) {
        console.error(err);
        restoreCart();
        freteLista.innerHTML = "";
        freteLista.style.display = "none";
        shippingMessage.innerHTML = config.errorMessage;
        shippingMessage.style.display = "block";
      });
    }
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
